import {
  Box,
  ButtonBase,
  Paper,
  StyledComponentProps,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import * as React from 'react';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';

import { ClassKey, useSxStyles } from './useStyles';

export interface Props extends StyledComponentProps<ClassKey> {
  count?: number;
  label: string;
  statusIndicator?: JSX.Element;
  disabled?: boolean;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const SummaryButton: React.FC<Props> = (props) => {
  const sxStyles = useSxStyles();
  const { sx } = props;

  return (
    <Paper
      sx={{
        ...(!!props.disabled ? sxStyles.disabled : sxStyles.root),
        ...sx,
      }}
      component={ButtonBase}
      onClick={!props.disabled ? props.onClick : undefined}
      data-cy="button"
    >
      <Box sx={sxStyles.primary}>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={sxStyles.count}
          data-cy="count"
        >
          {props.count !== undefined ? props.count : '-'}
        </Typography>
        {props.statusIndicator}
      </Box>
      <Typography
        variant="body1"
        color="textSecondary"
        sx={sxStyles.secondary}
        data-cy="label"
      >
        <TooltippedTruncatedText>{props.label}</TooltippedTruncatedText>
      </Typography>
    </Paper>
  );
};
